enum ServicesActions {
  FETCH_LIST = "servicesFetchList",
  GET_ITEM = "servicesGetItem",
  CREATE_ITEM = "servicesCreateItem",
  UPDATE_ITEM = "servicesUpdateItem",
  DELETE_ITEM = "servicesDeleteItem",
  UPDATE_TRANSLATION = "servicesUpdateTranslation",
  REFRESH_LIST = "servicesRefreshList",
  LIST_GROUPS = "servicesListGroups",
  GET_GROUP_TREE = "servicesGetGroupTree",
  ASSIGN_TO_GROUP = "servicesAssignToGroup",
  REMOVE_FROM_GROUP = "servicesRemoveFromGroup",
  REORDER_GROUP = "servicesReorderGroup",
  GET_GROUP_RELATIONS = "servicesGetGroupRelations",
  UPDATE_GROUP_RELATIONS = "servicesUpdateGroupRelations",
}

enum ServicesMutation {
  SET_RENDER_UPDATE = "servicesListRenderNeeded",
  SET_LIST_RESULT = "servicesListResult",
  SET_ACTIVE_TYPE = "servicesActiveType",
  SET_GROUPS = "servicesGroups",
}

export { ServicesActions, ServicesMutation };
